import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import ContentBlock from 'components/atoms/ContentBlock'
import Typography from 'components/atoms/Typography'
import TagTransparentBanner from 'components/molecules/TagTransparentBanner'
import { get } from 'lodash'

function TagTransparentBanners({ data }) {
  const title = get(data, 'title')
  const uuid = get(data, 'uuid')
  const items = get(data, 'items')
  const description = get(data, 'description.value')

  return (
    <Container fluid="fluid" className="tag-transparent-banners bg-primary py-5" id={uuid}>
      <Container>
        <Row>
          <Col sm={12}>
            <ContentBlock>
              <Typography variant="h3" color="white" cssClass="title-bold-md mb-3">
                {title}
              </Typography>
              <Typography variant="span" color="white" cssClass="mb-4">
                {ReactHtmlParser(description)}
              </Typography>
            </ContentBlock>
          </Col>
        </Row>
        <Row>
          {Array.isArray(items) &&
            items.map((item) => (
              <Col sm={12} md={4} className="mb-3" key={get(item, 'entity.uuid')}>
                <TagTransparentBanner
                  typeColor="white"
                  icon={get(item, 'entity.icon.entity.media.entity.fieldMediaFile.entity.url')}
                  title={get(item, 'entity.title')}
                  subtitle={get(item, 'entity.subtitle')}
                />
              </Col>
            ))}
        </Row>
      </Container>
    </Container>
  )
}

export default TagTransparentBanners
